
export * from '../../frontend-taglib-clay/__liferay__/exports/@clayui$panel.js';

import __default__ from '../../frontend-taglib-clay/__liferay__/exports/@clayui$panel.js';
export default __default__;
